export const getSelectOptions = list => {
  return list.map(item => {
    return {
      label: item,
      value: item,
    };
  });
};



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/utils/getSelectOptions.js